import React from "react";
import { FiTrash2 } from "react-icons/fi";

const ConfirmDeleteModal = ({
  title = "Delete closed date",
  description = "Are you sure you want to delete this closed date? This action cannot be undone.",
  onCancel,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />

      {/* Modal */}
      <div className="relative bg-dry rounded-lg shadow-xl w-full max-w-md p-6 z-10 border border-border m-3">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-yellowlight flex items-center justify-center text-red-600">
            <FiTrash2 size={18} />
          </div>
          <h2 className="text-lg font-semibold text-yellowlight">{title}</h2>
        </div>

        <p className="text-textGray mb-6">{description}</p>
        <hr className="border border-border mb-3" />
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="border border-border text-textGray px-4 py-2 rounded-md text-sm"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="bg-yellowlight hover:bg-yellowdark hover:text-yellowlight text-yellowdark px-4 py-2 rounded-md text-sm"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
